var map = {
	"./aks-black.svg": 1993,
	"./aks.svg": 1994,
	"./aliyun-black.svg": 1995,
	"./aliyun.svg": 1996,
	"./aliyunecs-black.svg": 1997,
	"./aliyunecs.svg": 1998,
	"./amazonec2-black.svg": 1999,
	"./amazonec2.svg": 2000,
	"./amazoneks-black.svg": 2001,
	"./amazoneks.svg": 2002,
	"./aws.svg": 2003,
	"./azure-black.svg": 2004,
	"./azure.svg": 2005,
	"./azuread-black.svg": 2006,
	"./azuread.svg": 2007,
	"./azureaks-black.svg": 2008,
	"./azureaks.svg": 2009,
	"./baidu-black.svg": 2010,
	"./baidu.svg": 2011,
	"./cloudca-black.svg": 2012,
	"./cloudca.svg": 2013,
	"./cloudscale-black.svg": 2014,
	"./cloudscale.svg": 2015,
	"./custom.svg": 2016,
	"./digitalocean-black.svg": 2017,
	"./digitalocean.svg": 2018,
	"./equinix-black.svg": 2019,
	"./equinix.svg": 2020,
	"./exoscale.svg": 2021,
	"./gcp.svg": 2022,
	"./gke-black.svg": 2023,
	"./gke.svg": 2024,
	"./google.svg": 2025,
	"./googlegke-black.svg": 2026,
	"./googlegke.svg": 2027,
	"./harvester.svg": 1266,
	"./huaweicce-black.svg": 2028,
	"./huaweicce.svg": 2029,
	"./import.svg": 2030,
	"./k3s-black.svg": 2031,
	"./k3s.svg": 2032,
	"./kubernetes-black.svg": 2033,
	"./kubernetes.svg": 686,
	"./linode.svg": 2034,
	"./linodelke-black.svg": 2035,
	"./linodelke.svg": 2036,
	"./local-cluster.svg": 2037,
	"./minikube-black.svg": 2038,
	"./minikube.svg": 2039,
	"./oci-black.svg": 2040,
	"./oci.svg": 2041,
	"./openstack-black.svg": 2042,
	"./openstack.svg": 2043,
	"./oracle.svg": 2044,
	"./oracleoke-black.svg": 2045,
	"./oracleoke.svg": 2046,
	"./otc-black.svg": 2047,
	"./otc.svg": 2048,
	"./otccce.svg": 2049,
	"./packet-black.svg": 2050,
	"./packet.svg": 2051,
	"./pinganyunecs-black.svg": 2052,
	"./pinganyunecs.svg": 2053,
	"./pnap-black.svg": 2054,
	"./pnap.svg": 2055,
	"./rackspace-black.svg": 2056,
	"./rackspace.svg": 2057,
	"./rke.svg": 2058,
	"./rke2.svg": 2059,
	"./softlayer.svg": 2060,
	"./tencenttke-black.svg": 2061,
	"./tencenttke.svg": 2062,
	"./vmwarevsphere-black.svg": 2063,
	"./vmwarevsphere.svg": 2064
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 685;